export default "__VITE_ASSET__NamG72qV__"